import React from "react";
import { useNavigate } from "react-router-dom";
import "./Start_Btn.css";

const Start_Btn = ({
  text,
  link,
  onClick,
  className = "",
  type = "button",
  disabled = false, // ADD THIS
}) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (disabled) return; //BLOCK CLICK

    if (link) {
      navigate(link);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <button
      type={type}
      className={`start_btn ${className} ${disabled ? "disabled" : ""}`} //STYLE
      onClick={handleClick}
      disabled={disabled} // HTML DISABLE
    >
      {text}
    </button>
  );
};

export default Start_Btn;
